import styled from 'styled-components';

const NotificationsContainerStyled = styled.div`
  position: fixed;
  // TODO: Change to a portal
  z-index: 9999;
  pointer-events: none;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  .NotificationsContainer {
    &__container {
      position: absolute;
      pointer-events: none;

      & > *:not(:last-child) {
        margin-bottom: 20px;
      }

      &--top-left {
        left: ${(props) => {
  var _a;
  return (_a = props.left) != null ? _a : 20;
}}px;
        top: ${(props) => {
  var _a;
  return (_a = props.top) != null ? _a : 20;
}}px;
      }

      &--top-right {
        right: ${(props) => {
  var _a;
  return (_a = props.right) != null ? _a : 20;
}}px;
        top: ${(props) => {
  var _a;
  return (_a = props.top) != null ? _a : 20;
}}px;
      }

      &--top-center {
        top: ${(props) => {
  var _a;
  return (_a = props.top) != null ? _a : 20;
}}px;
        left: 50%;
        transform: translateX(-50%);
      }

      &--bottom-left {
        left: ${(props) => {
  var _a;
  return (_a = props.left) != null ? _a : 20;
}}px;
        bottom: ${(props) => {
  var _a;
  return (_a = props.bottom) != null ? _a : 20;
}}px;
      }

      &--bottom-right {
        right: ${(props) => {
  var _a;
  return (_a = props.right) != null ? _a : 20;
}}px;
        bottom: ${(props) => {
  var _a;
  return (_a = props.bottom) != null ? _a : 20;
}}px;
      }

      &--bottom-center {
        bottom: ${(props) => {
  var _a;
  return (_a = props.bottom) != null ? _a : 20;
}}px;
        left: 50%;
        transform: translateX(-50%);
      }
    }

    &__item {
      position: relative;
      transition: 0.2s;
      pointer-events: all;
    }
  }
`;

export { NotificationsContainerStyled as default };
//# sourceMappingURL=bundle.esm3.js.map
